import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import routes from 'routes/routes';
import Offline from 'pages/offline';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import ConfigTheme from 'theme/config-theme';
import AdaChatProvider from 'contexts/AdaChatContext';
import useDocumentTitle from 'hooks/useDocumentTitle';
import useOnlineStatus from 'hooks/useOnlineStatus';
import { logErrors } from 'utils';
import fetchBrandDetails from 'services/brand/brandAsync';
import { selectIsBrandDetailsExist } from 'services/brand/brandSelectors';

function App() {
  useDocumentTitle();
  const dispatch = useAppDispatch();
  const isOnline = useOnlineStatus();
  const isBrandDetailsExist = useAppSelector(selectIsBrandDetailsExist);

  /* Fetch brand details if not exist */
  useEffect(() => {
    async function getBrandDetails() {
      try {
        await dispatch(fetchBrandDetails());
      } catch (error) {
        logErrors(error);
      }
    }

    if (isOnline && !isBrandDetailsExist) {
      getBrandDetails();
    }
  }, [isBrandDetailsExist, isOnline]);

  if (!isOnline) {
    return <Offline />;
  }

  return (
    <ConfigTheme>
      <AdaChatProvider>
        <RouterProvider router={routes} />
      </AdaChatProvider>
    </ConfigTheme>
  );
}

export default App;
